import React from 'react';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const PerformanceRuleExecutedActionActivityTypeCellRenderer = ({ data: { actionType } }) => (
    <FormattedMessage
        id={`performance.rule.executed.actions.report.actionType.${actionType}`}
        defaultMessage={actionType}
    />
);
